var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconresearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 0H5.00015C4.2045 0 3.44144 0.31607 2.87883 0.87868C2.31622 1.44129 2.00015 2.20435 2.00015 3V21C2.00015 21.7956 2.31622 22.5587 2.87883 23.1213C3.44144 23.6839 4.2045 24 5.00015 24H22.0002V2C22.0002 1.46957 21.7894 0.960859 21.4144 0.585786C21.0393 0.210714 20.5306 0 20.0002 0V0ZM20.0002 18H8.00015V2H20.0002V18ZM5.00015 2H6.00015V18H5.01715C4.66988 18.003 4.32577 18.0663 4.00015 18.187V3C4.00015 2.73478 4.10551 2.48043 4.29305 2.29289C4.48058 2.10536 4.73494 2 5.00015 2ZM5.00015 22C4.73632 22 4.48317 21.8958 4.29586 21.7099C4.10855 21.5241 4.00226 21.2718 4.00015 21.008H4.01515C4.0141 20.876 4.03918 20.7451 4.08896 20.6229C4.13875 20.5006 4.21224 20.3894 4.3052 20.2957C4.39817 20.202 4.50876 20.1276 4.63061 20.0769C4.75246 20.0261 4.88315 20 5.01515 20H20.0002V22H5.00015Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconresearch);
export default __webpack_public_path__ + "static/media/icon=research.c974b0fe5656458db2b61392019261d4.svg";
export { ForwardRef as ReactComponent };